import { PayloadAction } from '../../../store.model';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { SelectTemplateVersion } from './select-template-version.action';

export function selectTemplateVersionReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.EVAL_MAIN__SELECT_TEMPLATE_VERSION,
        SelectTemplateVersion
    >,
): MainState {
    return {
        ...state,
        selectedTemplateVersionId: {
            value: action.payload.templateVersionId,
        },
    };
}
